import React from "react";

/**
 * "Where this credit comes from" block — shown on /project/:id detail page
 * when provenance metadata is present (producer or BMV unit id).
 */
export default function ProvenancePanel({ p }) {
  if (!p?.producer && !p?.bmv_unit_id) return null;
  return (
    <div className="mt-10 border border-ink" data-testid="provenance-section">
      <div className="p-5 border-b border-line bg-muted/40 flex items-center justify-between">
        <div>
          <div className="label-tag">UCS Origin · Verified by BMV Global</div>
          <div className="font-serif text-2xl mt-1">Where this credit comes from</div>
        </div>
        <div className="mono-num text-xs text-ink2">{p.bmv_unit_id}</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line">
        <Row k="Producer" v={p.producer} />
        <Row k="Property" v={p.property_name} />
        <Row k="Hectares" v={p.hectares != null ? `${p.hectares.toLocaleString()} ha` : "—"} />
        <Row k="Coordinates" v={p.latitude != null ? `${p.latitude}, ${p.longitude}` : "—"} />
        <Row k="CPR Verde" v={p.cpr_number} mono />
        <Row k="Blockchain tx" v={p.blockchain_tx} mono />
        <Row k="Audit firm" v={p.audit_firm} />
        <Row k="BMV Unit ID" v={p.bmv_unit_id} mono />
      </div>
    </div>
  );
}

function Row({ k, v, mono }) {
  return (
    <div className="bg-surface p-4">
      <div className="label-tag">{k}</div>
      <div className={`mt-1 text-sm ${mono ? "font-mono text-ink" : "text-ink"}`}>{v || "—"}</div>
    </div>
  );
}
